import {Component, Inject} from '@angular/core';
import { AceitarProposta} from "../../../../aplicacao/models/aceitar-proposta.model";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from "@angular/material/bottom-sheet";

@Component({
  selector: 'app-aceitar-proposta',
  templateUrl: './aceitar-proposta.component.html',
  styleUrls: ['./aceitar-proposta.component.scss']
})
export class AceitarPropostaComponent {
  model = new AceitarProposta();
  validarFormulario = true;
  constructor(
    private bottomSheetRef: MatBottomSheetRef<AceitarPropostaComponent>,
    public dialogRef: MatDialogRef<AceitarPropostaComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    @Inject(MAT_BOTTOM_SHEET_DATA) public dataBottom,
  ) {}

  enviar(): void {
    if(this.model.form.valid) {
      if (this.data.tipo === 'MODAL') {
        this.dialogRef.close(this.model.form.value);
      } else {
        this.bottomSheetRef.dismiss(this.model.form.value);
      }
    } else {
      this.validarFormulario = false;
    }
  }

  fechar(): void {
    if (this.data.tipo === 'MODAL') {
      this.dialogRef.close(false);
    } else {
      this.bottomSheetRef.dismiss(false);
    }
  }
}
